import { gql } from 'apollo-boost';

export const READATHON_OVERALL_STATS = gql`
query readathonOverallStats($itemsCounter: Int!, $startFrom: String!, $endOn: String!) {
    readathonOverallStats(itemsCounter: $itemsCounter, startFrom: $startFrom, endOn: $endOn) {
        id
        schoolName
        score
    }
}
`;